import { FC, ChangeEvent, Fragment, useState, useEffect, useMemo, useRef } from 'react';
import {
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Table,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  CardHeader,
  ListSubheader,
  Tooltip
} from '@mui/material';
import styled from '@emotion/styled';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CancelPresentationOutlinedIcon from '@mui/icons-material/CancelPresentationOutlined';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, useNavigate, useParams } from 'react-router';
import { withStyles } from '@mui/styles';
import {
  filterLeaveHistory,
  getLeaveHistory,
  searchLeaveHistory
} from 'src/services/leaveService';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { AppActions } from 'src/store/AppReducer';
import { leavesArray } from 'src/constant/constant';
import CancelLeaveModal from './CancelLeaveModal';
import {
  CANCELLATION_IN_REVIEW_MESSAGE,
  CANCELLATION_WINDOW_CLOSED_MESSAGE,
  doesCancellationRequireApproval,
  isCancellationInReview,
  isWithinCancellationWindow
} from './utils/cancellationUtils';
import SnackBar from 'src/components/SnackBar/SnackBar';
import moment from 'moment';
import { DatePicker } from '@mui/lab';
import TotalLeaves from './TotalLeaves';

interface Filters {
  status?: any;
}

const LeaveHistory = () => {
  const { id } = useParams();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const employeeType = useSelector(
    (state: RootStateType) =>
      state.leaveManagementReducer.userDetails.employmentType
  );
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [filters] = useState<Filters>({ status: null });
  const [toggleFilter, setToggleFilter] = useState(false);

  const [sortDate, setSortDate] = useState<'asc' | 'desc'>('desc');
  const [employeeLeaveList, setEmployeeLeaveList] = useState([]);
  const [leaveList, setLeaveList] = useState<any>([]);
  const [searchString, setSearchString] = useState('');

  const [leaveType, setLeaveType] = useState(' ');
  const [leaveStatus, setLeaveStatus] = useState(' ');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [leave, setLeave] = useState<any>([]);
  const [availableStatus, setAvailableStatus] = useState<any>([]);
  const [isDisabled, setIsDisable] = useState(true);
  const inputRefFrom = useRef<HTMLInputElement>(null);
  const inputRefTo = useRef<HTMLInputElement>(null);
  const [isDisabledRMPendingBtn, setIsDisabledRMPendingBtn] =
    useState<boolean>(false);
  const [breadcrumbs, setBreadcrumbs] = useState<boolean>(false);
  const [isDisabledClearBtn, setIsDisabledClearBtn] = useState<boolean>(true);
  const [isDisabledEmployeeLeavesBtn, setIsDisabledEmployeeLeavesBtn] =
    useState<boolean>(false);
  const [selectFormDate, setSelectFormDate] = useState('');
  const [expandedGroups, setExpandedGroups] = useState<string[]>([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const employeeId = useSelector(
    (state: RootStateType) => state.appReducer.user.EmployeeId
  );
  const isReportingManager = useSelector(
    (state: RootStateType) => state.leaveManagementReducer.isReportingManager
  );

  let query = useQuery();

  useEffect(() => {
    if (searchString) {
      try {
        dispatch(AppActions.showLoader());
        setPage(0);
        searchLeave(searchString);
      } catch (e) {
        dispatch(AppActions.hideLoader());
      }
    } else {
      leavesHistory(query.get('name') ? id : employeeId);
    }
  }, [searchString]);

  useEffect(() => {
    const user = window.localStorage.getItem('user');
    const userModel = JSON.parse(user);
    const selectedUserRole = userModel?.Roles;

    const user_role = selectedUserRole.split(',');
    if (
      user_role.includes('Super User') ||
      user_role.includes('HR Manager') ||
      user_role.includes('Assistant HR Manager') ||
      user_role.includes('HR Executive')
    ) {
      setIsDisabledRMPendingBtn(true);
      setBreadcrumbs(false);
      setIsDisabledEmployeeLeavesBtn(true);
    } else if (isReportingManager) {
      setIsDisabledRMPendingBtn(false);
      setBreadcrumbs(false);
      setIsDisabledEmployeeLeavesBtn(true);
    } else {
      setIsDisabledRMPendingBtn(false);
      setBreadcrumbs(true);
      setIsDisabledEmployeeLeavesBtn(false);
    }
  }, []);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const applyFilters = (leaveList: any[]): any[] => {
    return leaveList.filter(() => {
      let matches = true;

      return matches;
    });
  };

  const applyPagination = (
    leaveList: any[],
    page: number,
    limit: number
  ): any[] => {
    return leaveList.slice(page * limit, page * limit + limit);
  };

  const [searchText, setSearchText] = useState<any>('');

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const leaveTypes = useMemo(
    () => leave?.filter((option) => containsText(option, searchText)),
    [searchText, leave]
  );


const handleSortDateChange = () => {
  setSortDate((prev) => (prev === 'asc' ? 'desc' : 'asc'));
  setPage(0); // Reset to first page on sort change
};


const leavesHistory = (employeeId: string) => {
  dispatch(AppActions.showLoader());
  getLeaveHistory(employeeId)
    .then((res) => {
      if (res.data) {
          //reorder by latest from date
          //const reorderByFormDate = res.data?.data.sort((a,b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
          setLeaveList(res.data?.data);
          getDropDownValues(res.data.data);
      }
      dispatch(AppActions.hideLoader());
    })
    .catch((e) => {
      dispatch(AppActions.hideLoader());
    });
};

const searchLeave = (searchString: string) => {
  dispatch(AppActions.showLoader());
  searchLeaveHistory(
    searchString,
    query.get('name') ? id : employeeId
  )
    .then((res) => {
      if (res.data) {
          //reorder by latest from date
          //const reorderByFormDate = res.data?.data.sort((a,b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
          setLeaveList(res.data?.data);
          getDropDownValues(res.data.data);
      }
      dispatch(AppActions.hideLoader());
    })
    .catch((e) => {
      dispatch(AppActions.hideLoader());
    });
};

  const getDropDownValues = (data) => {
    const temLeaveTypeList = [];
    const leaveTypeList = data.map((item) => {
      temLeaveTypeList.push(item.typeName);
      if (item.isEligible) {
        temLeaveTypeList.push('Lieu Leave Eligibility');
      }
    });
    const leaveStatusList = data.map((item) => ({
      status: item.status,
      hrApproved: item.hrApproved
    }));

    leavesArray.forEach((typeName) => {
      if (!temLeaveTypeList.includes(typeName)) {
        temLeaveTypeList.push(typeName);
      }
    });
    setLeave(
      temLeaveTypeList.filter(
        (item, index) => temLeaveTypeList.indexOf(item) === index
      )
    );
    validateLeaveStatusList(
      leaveStatusList.filter(
        (item, index) => leaveStatusList.indexOf(item) === index
      )
    );
  };

  const validateLeaveStatusList = (data) => {
    const tempArr = [];
    data.map((item) =>
      tempArr.push(validateLeaveStatus(item.status, item.hrApproved, item.typeName))
    );

    const uniqueStatus = [];
    tempArr.map((item) => {
      if (uniqueStatus.indexOf(item) === -1) {
        uniqueStatus.push(item);
      }
    });

    setAvailableStatus(uniqueStatus);
  };

const sortLeaveList = (list: any[], sortDate: 'asc' | 'desc') => {
  return [...list].sort((a, b) => {
    const reqA = new Date(a.leaveRequestDate).getTime();
    const reqB = new Date(b.leaveRequestDate).getTime();

    if (reqA === reqB) {
      // If requested dates are equal, compare fromDate
      const fromA = new Date(a.fromDate).getTime();
      const fromB = new Date(b.fromDate).getTime();
      return sortDate === 'asc' ? fromA - fromB : fromB - fromA;
    } else {
      return sortDate === 'asc' ? reqA - reqB : reqB - reqA;
    }
  });
};

  const getLeaveGroupId = (leave: any) => leave?.groupId || leave?.group_id;

  const isApprovedLeaveStatus = (status, hrApproved) =>
    status === 'APPROVED' ||
    status === 'HR_APPROVED' ||
    (status === 'RM_APPROVED' && !hrApproved);

  const getGroupDisplayStatus = (leaves: any[]) => {
    if (!leaves?.length) {
      return { status: '', hrApproved: false };
    }

    const allSame = leaves.every(
      (item) =>
        item.status === leaves[0].status &&
        item.hrApproved === leaves[0].hrApproved
    );
    if (allSame) {
      return {
        status: leaves[0].status,
        hrApproved: leaves[0].hrApproved
      };
    }

    // Mixed statuses: if any day is approved, parent shows Partially Approved
    const hasApproved = leaves.some((item) =>
      isApprovedLeaveStatus(item.status, item.hrApproved)
    );
    if (hasApproved) {
      return {
        status: 'PARTIALLY_APPROVED',
        hrApproved: true
      };
    }

    // Mixed without approved: keep an active leave status.
    // Cancellation Requested / Cancelled apply only on the specific day rows.
    const activeLeave = leaves.find(
      (item) =>
        item.status !== 'CANCELLATION_REQUESTED' && item.status !== 'CANCELLED'
    );
    if (activeLeave) {
      return {
        status: activeLeave.status,
        hrApproved: activeLeave.hrApproved
      };
    }

    if (leaves.every((item) => item.status === 'CANCELLED')) {
      return {
        status: 'CANCELLED',
        hrApproved: leaves[0].hrApproved
      };
    }

    return {
      status: 'CANCELLATION_REQUESTED',
      hrApproved: leaves[0].hrApproved
    };
  };

  const groupLeaveRequests = (list: any[]) => {
    const result: any[] = [];
    const seenGroupIds = new Set<string>();

    list.forEach((leave) => {
      const groupId = getLeaveGroupId(leave);

      if (!groupId) {
        result.push({ isGroup: false, leaves: [leave] });
        return;
      }

      if (seenGroupIds.has(groupId)) {
        return;
      }

      seenGroupIds.add(groupId);
      const groupLeaves = list
        .filter((item) => getLeaveGroupId(item) === groupId)
        .sort(
          (a, b) =>
            new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime()
        );

      if (groupLeaves.length === 1) {
        result.push({ isGroup: false, leaves: groupLeaves });
      } else {
        const earliestFrom = groupLeaves.reduce((earliest, item) =>
          new Date(item.fromDate).getTime() < new Date(earliest.fromDate).getTime()
            ? item
            : earliest
        );
        const latestTo = groupLeaves.reduce((latest, item) =>
          new Date(item.toDate).getTime() > new Date(latest.toDate).getTime()
            ? item
            : latest
        );

        result.push({
          isGroup: true,
          groupId,
          leaves: groupLeaves,
          fromDate: earliestFrom.fromDate,
          toDate: latestTo.toDate,
          daysCount: groupLeaves.reduce(
            (sum, item) => sum + (Number(item.daysCount) || 0),
            0
          ),
          leaveRequestDate: groupLeaves[0].leaveRequestDate,
          typeName: groupLeaves[0].typeName,
          dateType: groupLeaves[0].dateType,
          ...getGroupDisplayStatus(groupLeaves),
          isEligible: groupLeaves[0].isEligible
        });
      }
    });

    return result;
  };

  const toggleGroupExpand = (groupId: string) => {
    setExpandedGroups((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    );
  };

  const filteredLeaveList = applyFilters(leaveList);
  const sortedLeaveList = sortLeaveList(filteredLeaveList, sortDate);
  const groupedLeaveList = groupLeaveRequests(sortedLeaveList);
  const paginatedLeaveList = applyPagination(groupedLeaveList, page, limit);


  const NavigateToEditSection = (employeeId: number, view) => {
    navigate('edit-employee/' + employeeId);
    navigate(`edit-employee/${employeeId}?view=${view}`);
  };

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem',
      width: '4.2rem'
    }
  })(TableRow);

  const isFullOrHalfDayLeave = (leave) => {
    if (!leave) {
      return false;
    }
    // Short Leave (and similar) are not Full Day / Half Day
    if (leave.typeName === 'Short Leave') {
      return false;
    }
    // Full Day (true) or Half Day (false)
    return typeof leave.dateType === 'boolean';
  };

  const isLeaveCancellable = (leave) =>
    Boolean(leave?.cancellationEligible) &&
    isWithinCancellationWindow(leave) &&
    !isCancellationInReview(leave) &&
    leave?.status !== 'CANCELLED' &&
    isFullOrHalfDayLeave(leave);

  const getCancelTooltip = (leave) => {
    if (isLeaveCancellable(leave)) {
      return doesCancellationRequireApproval(leave)
        ? 'Cancel leave'
        : 'Cancel leave';
    }
    if (isCancellationInReview(leave)) {
      return CANCELLATION_IN_REVIEW_MESSAGE;
    }
    if (!isFullOrHalfDayLeave(leave)) {
      return (
        leave?.cancellationIneligibleReason ||
        'Only Full Day or Half Day leaves can be cancelled completely. Shorter/longer leaves are not allowed to be removed.'
      );
    }
    if (
      leave?.status !== 'CANCELLED' &&
      !isWithinCancellationWindow(leave)
    ) {
      return CANCELLATION_WINDOW_CLOSED_MESSAGE;
    }
    return leave?.cancellationIneligibleReason || 'Leave cannot be cancelled';
  };

  const validateLeaveStatus = (status, hrApproved, leaveType) => {
    if (leaveType === 'No Pay Leave') {
      if (status === 'PENDING') {
        return 'Pending';
      } else if (status === 'HR_APPROVED') {
        return 'HR Manager Approved';
      } else if (status === 'HR_REJECTED') {
        return 'HR Manager Rejected';
      } else if (status === 'CANCELLATION_REQUESTED') {
        return 'Cancellation Requested';
      } else if (status === 'CANCELLATION_REJECTED') {
        return 'Cancellation Rejected';
      } else if (status === 'CANCELLED') {
        return 'Cancelled';
      }
    }
    if (status === 'PARTIALLY_APPROVED') {
      return 'Partially Approved';
    } else if (
      status === 'APPROVED' ||
      status === 'HR_APPROVED' ||
      (status === 'RM_APPROVED' && !hrApproved)
    ) {
      return 'Approved';
    } else if (status === 'RM_APPROVED' && hrApproved) {
      return 'Approved by PM/RM';
    } else if (status === 'HR_REJECTED') {
      return 'Rejected by HR';
    } else if (status === 'RM_REJECTED') {
      return 'Rejected';
    } else if (status === 'PENDING') {
      return 'Pending';
    } else if (status === 'CANCELLATION_REQUESTED') {
      return 'Cancellation Requested';
    } else if (status === 'CANCELLATION_REJECTED') {
      return 'Cancellation Rejected';
    } else if (status === 'CANCELLED') {
      return 'Cancelled';
    }
  };

  const validateLeaveStatusColor = (status) => {
    if (status === 'PARTIALLY_APPROVED') {
      return '#2E7D32';
    } else if (
      status === 'APPROVED' ||
      status === 'RM_APPROVED' ||
      status === 'HR_APPROVED'
    ) {
      return '#00d688';
    } else if (status === 'HR_REJECTED' || status === 'RM_REJECTED') {
      return '#FF1943';
    } else if (status === 'PENDING') {
      return '#FFA319';
    } else if (status === 'CANCELLATION_REQUESTED') {
      return '#FF1943';
    } else if (status === 'CANCELLATION_REJECTED') {
      return '#E65100';
    } else if (status === 'CANCELLED') {
      return '#3376c9';
    }
  };

  const initialDate = (isFromDate: Boolean) => {
    if (!isFromDate && fromDate) {
      const minDate = new Date(fromDate.split('/').reverse().join('-'));
      return minDate.toISOString().split('T')[0];
    } else {
      if (toDate) {
        const minDate = new Date(toDate.split('/').reverse().join('-'));
        return minDate.toISOString().split('T')[0];
      }
    }
    return null;
  };

const getFilteredData = () => {
  dispatch(AppActions.showLoader());
  setPage(0);
  const optionalData = {
    status: leaveStatus !== ' ' ? leaveStatus : '',
    toDate: toDate,
    fromDate: fromDate,
    leaveType: leaveType !== ' ' ? leaveType : ''
  };
  filterLeaveHistory(
    query.get('name') ? id : employeeId,
    optionalData
  )
    .then((res) => {
      if (res.data) {
          //reorder by latest from date
          //const reorderByFormDate = res.data?.data.sort((a,b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime());
          setLeaveList(res.data?.data);
      }
      dispatch(AppActions.hideLoader());
    })
    .catch((e) => {
      dispatch(AppActions.hideLoader());
    });
};

  const useStyles = makeStyles({
    root: {
      textAlign: 'center'
    }
  });

  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(!open);
  };

  const [leaveData, setLeaveData] = useState('');

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [isSelectToDate, setIsSelectToDate] = useState('');
  const [isSelectFromDate, setIsSelectFromDate] = useState('');

  //set disabled filter button
  const filterMandatoryField = (e) => {
    if (e) {
      fromDate
        ? toDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : toDate
        ? fromDate
          ? setIsDisable(false)
          : setIsDisable(true)
        : setIsDisable(false);
    }
  };

  return (
    <>
      <Grid sx={{ mx: 3 }}>
        <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
          <Grid item>
            <Typography
              style={{
                marginLeft: '0px',
                fontWeight: '700',
                fontSize: '16px',
                fontFamily:
                  'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
              }}
            >
              {!breadcrumbs && (
                <span
                  style={{
                    cursor: 'pointer',
                    marginRight: '3px'
                  }}
                  onClick={() => {
                    navigate('/leave-management');
                  }}
                >
                  Leave Management
                </span>
              )}
              {!breadcrumbs && (
                <>
                  {query.get('name') ? (
                    <>
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: '550',
                          color: '#223354',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          navigate(`/leave-management/employee-leaves`);
                        }}
                      >
                        / Employee Leaves
                      </span>
                      <span
                        style={{
                          fontSize: '14px',
                          fontWeight: '550',
                          color: '#223354',
                        }}
                      >
                        / {query.get('name')}
                      </span>
                    </>
                  ) : (
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: '550',
                        color: '#223354'
                      }}
                    >
                      / History
                    </span>
                  )}
                </>
              )}
              {breadcrumbs && (
                <span
                  style={{
                    marginRight: '3px'
                  }}
                >
                  History
                </span>
              )}
            </Typography>
            <Typography variant="subtitle2"></Typography>
          </Grid>
          <Grid item>
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-leave`);
              }}
            >
              Apply Leave
            </Button>
            {/* <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-wfh`);
              }}
            >
              Apply Work From Home
            </Button> */}
            {employeeType === 'Permanent' && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/apply-lieu-leave`);
                }}
              >
                Apply Lieu Leave
              </Button>
            )}
            {isDisabledRMPendingBtn && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/RM-pending-requests`);
                }}
              >
                PM/RM Pending Requests
              </Button>
            )}
            {isDisabledEmployeeLeavesBtn && (
              <Button
                sx={{
                  mr: 2,
                  mt: { xs: 2, md: 0 },
                  fontSize: '11px',
                  fontWeight: 'normal'
                }}
                variant="contained"
                style={{ height: '1.75rem' }}
                onClick={(e) => {
                  navigate(`/leave-management/employee-leaves`);
                }}
              >
                Employee Leaves
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid xs={12} sx={{ display: 'flex' }}>
          <Grid xs={query.get('name') ? 8 : 12}>
            <Card style={{ minHeight: '30rem'}}>
              <Grid sx={{ px: 2, py: 2 }} item xs={6}>
                {query.get('name') && (
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginBottom: '1rem'
                    }}
                  >
                    Leave History
                  </Typography>
                )}
                <TextField
                  sx={{ width: 320, mr: 2 }}
                  size="small"
                  id="searchLeave"
                  placeholder="Search (Leave Type)"
                  InputProps={{
                    style: { fontSize: '12px', height: '1.75rem' },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          sx={{ color: '#d3d3d3' }}
                          style={{ fontSize: '15px' }}
                        />
                      </InputAdornment>
                    )
                  }}
                  value={searchString}
                  onChange={(e) => setSearchString(e.target.value)}
                />
                <Button
                  sx={{
                    mt: { xs: 2, md: 0 },
                    color: `${!toggleFilter && 'gray'}`
                  }}
                  variant="outlined"
                  startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
                  style={{ height: '1.75rem', fontSize: '12px' }}
                  onClick={() => {
                    setToggleFilter(!toggleFilter);
                    setIsSelectToDate('');
                    setIsSelectFromDate('');
                    setFromDate('');
                    setToDate('');
                    setLeaveStatus(' ');
                    setLeaveType(' ');
                    setIsDisable(true);
                    setIsDisabledClearBtn(true);
                    setSelectFormDate('');
                  }}
                >
                  Filters
                </Button>
              </Grid>
              {toggleFilter && (
                <Grid px={2} pb={2} style={{margin: 0}}>
                  <form>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        display: 'flex',
                        paddingTop: 2,
                        paddingBottom: 2,
                        justifyContent: 'between'
                      }}
                    >
                      <Grid
                        item
                        xs={3}
                      >
                        <InputLabel
                          style={{
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          From
                        </InputLabel>
                        <div style={{ marginTop: 7 }}>
                          <FormControl fullWidth>
                            <DatePicker
                              InputProps={{
                                className: 'date-picker-leaveManagement'
                              }}
                              renderInput={(params) => (
                                <TextField {...params} id="filterFormDate" />
                              )}
                              value={selectFormDate ? selectFormDate : null}
                              onChange={(newValue) => {
                                if (newValue) {
                                  setIsDisabledClearBtn(false);
                                  setIsSelectFromDate('');
                                  setFromDate(
                                    moment(newValue).format('YYYY-MM-DD')
                                  );
                                  setSelectFormDate(
                                    moment(newValue).format('YYYY-MM-DD')
                                  );
                                  setToDate('');
                                  setIsDisable(true);
                                  setIsSelectToDate(
                                    'To date is mandatory field'
                                  );
                                }
                              }}
                            />
                          </FormControl>
                        </div>
                        {isSelectFromDate && (
                          <>
                            <Typography
                              style={{
                                fontSize: '11px'
                              }}
                              color="red"
                            >
                              {isSelectFromDate}
                            </Typography>
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={3}
                      >
                        <InputLabel
                          style={{
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          To
                        </InputLabel>
                        <div style={{ marginTop: 7 }}>
                          <FormControl fullWidth>
                            <DatePicker
                              disabled={!fromDate}
                              InputProps={{
                                className: 'date-picker-leaveManagement'
                              }}
                              minDate={new Date(selectFormDate)}
                              renderInput={(params) => (
                                <TextField {...params} id="filterToDate" />
                              )}
                              value={toDate ? toDate : null}
                              onChange={(newValue) => {
                                if (newValue) {
                                  setIsDisabledClearBtn(false);
                                  setIsSelectToDate('');
                                  setToDate(
                                    moment(newValue).format('YYYY-MM-DD')
                                  );
                                  if (!fromDate) {
                                    setIsDisable(true);
                                    setIsSelectFromDate(
                                      'Form date is mandatory field'
                                    );
                                  } else {
                                    setIsDisable(false);
                                  }
                                }
                              }}
                            />
                          </FormControl>
                        </div>
                        {isSelectToDate && (
                          <>
                            <Typography
                              style={{
                                fontSize: '11px'
                              }}
                              color="red"
                            >
                              {isSelectToDate}
                            </Typography>
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={3}
                      >
                        <InputLabel
                          style={{
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          Leave Type
                        </InputLabel>
                        <FormControl fullWidth>
                          <Select
                            sx={{ mt: 1 }}
                            id="leaveType"
                            style={{
                              fontSize: '12px',
                              height: '2.1rem'
                            }}
                            fullWidth
                            size="small"
                            value={leaveType || ' '}
                            defaultValue={' '}
                            onClose={() => {
                              setSearchText('');
                            }}
                            onChange={(e) => {
                              setLeaveType(e.target.value);
                              filterMandatoryField(e.target.value);
                              setIsDisabledClearBtn(false);
                            }}
                          >
                            <MenuItem
                              style={{ display: 'none' }}
                              selected
                              disabled
                              value={' '}
                            >
                              Select Type
                            </MenuItem>
                            <ListSubheader>
                              <TextField
                                size="small"
                                autoFocus
                                placeholder="Type to search..."
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon />
                                    </InputAdornment>
                                  )
                                }}
                                onChange={(e) => {
                                  setSearchText(e.target.value);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key !== 'Escape') {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                  }
                                }}
                              />
                            </ListSubheader>
                            {leaveTypes?.length > 0 &&
                              leaveTypes?.map((element, index) => (
                                <MenuItem key={index} value={element}>
                                  {element}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={3}
                      >
                        <InputLabel
                          style={{
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          Status
                        </InputLabel>
                        <FormControl fullWidth>
                          <Select
                            sx={{ mt: 1 }}
                            style={{
                              fontSize: '12px',
                              height: '2.1rem'
                            }}
                            fullWidth
                            size="small"
                            value={leaveStatus || ' '}
                            defaultValue=" "
                            onClose={() => {
                              setSearchText('');
                            }}
                            onChange={(e) => {
                              setLeaveStatus(e.target.value);
                              filterMandatoryField(e.target.value);
                              setIsDisabledClearBtn(false);
                            }}
                          >
                            <ListSubheader>
                              <TextField
                                size="small"
                                autoFocus
                                placeholder="Type to search..."
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon />
                                    </InputAdornment>
                                  )
                                }}
                                onChange={(e) =>
                                  setSearchText(e.target.value)
                                }
                                onKeyDown={(e) => {
                                  if (e.key !== 'Escape') {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                  }
                                }}
                              />
                            </ListSubheader>
                            <MenuItem
                              style={{ display: 'none' }}
                              selected
                              disabled
                              value=" "
                            >
                              Select Status
                            </MenuItem>
                            {availableStatus &&
                              availableStatus?.map((element, i) => (
                                <MenuItem key={i} value={element}>
                                  {element}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid
                        container
                        xs={9}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          marginTop: 16,
                          marginLeft: 'auto'
                        }}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 1 }}
                          variant="outlined"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                          id="historyFilterClear"
                          disabled={isDisabledClearBtn}
                          className={isDisabledClearBtn &&'clear-btn'}
                          onClick={() => {
                            setLeaveStatus(' ');
                            setLeaveType(' ');
                            setFromDate('');
                            setToDate('');
                            setIsDisable(true);
                            leavesHistory(
                              query.get('name')
                                ? id
                                : employeeId
                            );
                            setSearchString('');
                            setIsSelectToDate('');
                            setIsSelectFromDate('');
                            setIsDisabledClearBtn(true);
                            setSelectFormDate('');
                            if (inputRefFrom.current) {
                              inputRefFrom.current.value = '';
                            }
                            if (inputRefTo.current) {
                              inputRefTo.current.value = '';
                            }
                          }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          id="historyFilterSubmit"
                          variant="outlined"
                          type="button"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                          onClick={() => getFilteredData()}
                          disabled={isDisabled}
                          className={isDisabled &&'filter-btn'}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
              <Divider />
              <TableContainer className="tableContainer">
                <Table size="small">
                  <TableHead>
                    <CustomTableRow>
                      <TableHeaderCell 
                        content="Requested Date" 
                        smallFont 
                        sort
                        setSortType={handleSortDateChange}
                        sortType={sortDate}/>
                      <TableHeaderCell content="From" smallFont />
                      <TableHeaderCell content="To" smallFont />
                      <TableHeaderCell content="Days Count" smallFont />
                      <TableHeaderCell content="Full Day/Half Day" smallFont />
                      <TableHeaderCell content="Leave Type" smallFont />
                      <TableHeaderCell content="Status" smallFont />
                      <TableHeaderCell content="Actions" smallFont />
                    </CustomTableRow>
                  </TableHead>

                  <TableBody className={classes.root}>
                    {paginatedLeaveList &&
                      paginatedLeaveList.map((group) => {
                        const isExpanded =
                          group.isGroup &&
                          expandedGroups.includes(group.groupId);
                        const parentLeave = group.isGroup
                          ? group
                          : group.leaves[0];

                        const renderLeaveCells = (
                          leave: any,
                          options: {
                            showActions?: boolean;
                            isChild?: boolean;
                            showExpand?: boolean;
                            isExpanded?: boolean;
                            groupId?: string;
                            dayIndex?: number;
                            totalDays?: number;
                          } = {}
                        ) => {
                          const {
                            showActions = true,
                            isChild = false,
                            showExpand = false,
                            isExpanded = false,
                            groupId,
                            dayIndex = 0,
                            totalDays = 0
                          } = options;
                          return (
                            <>
                              <TableColumnCell>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '20px',
                                      minWidth: '20px',
                                      height: '20px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginRight: '6px',
                                      flexShrink: 0,
                                      marginLeft: isChild ? '15px' : '0px'
                                    }}
                                  >
                                    {showExpand ? (
                                      <Button
                                        id={
                                          isExpanded
                                            ? `btn-expandLess-${groupId}`
                                            : `btn-expandMore-${groupId}`
                                        }
                                        className="tree-button"
                                        sx={{
                                          fontSize: '11px',
                                          fontWeight: 'normal',
                                          width: '14px',
                                          height: '14px',
                                          padding: 0,
                                          minWidth: 'unset',
                                          borderRadius: '2px',
                                          cursor: 'pointer',
                                        }}
                                        onClick={() =>
                                          toggleGroupExpand(groupId)
                                        }
                                        variant="contained"
                                        startIcon={
                                          isExpanded ? (
                                            <HorizontalRuleIcon
                                              fontSize="small"
                                              style={{ fontSize: '14px' }}
                                            />
                                          ) : (
                                            <AddTwoToneIcon
                                              fontSize="small"
                                              style={{ fontSize: '14px' }}
                                            />
                                          )
                                        }
                                      />
                                    ) : isChild ? (
                                      <SubdirectoryArrowRightIcon
                                        sx={{
                                          fontSize: '18px',
                                          color: '#5569ff'
                                        }}
                                      />
                                    ) : null}
                                  </div>
                                  <Typography
                                    variant="body2"
                                    style={{
                                      fontSize: '11px',
                                      margin: 0,
                                      lineHeight: '20px'
                                    }}
                                    noWrap
                                  >
                                    {isChild
                                      ? `Day ${dayIndex + 1} of ${totalDays}`
                                      : leave.leaveRequestDate}
                                  </Typography>
                                </div>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  gutterBottom
                                  noWrap
                                >
                                  {leave.fromDate}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {leave.toDate}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {leave.daysCount}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {leave.typeName === 'Short Leave'
                                    ? 'N/A'
                                    : leave.dateType
                                    ? 'Full Day'
                                    : 'Half Day'}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{ fontSize: '11px' }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {leave.isEligible
                                    ? 'Lieu Leave Eligibility'
                                    : leave.typeName}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                <Typography
                                  paddingBottom="0.25rem"
                                  paddingTop="0.5rem"
                                  variant="body2"
                                  style={{
                                    fontSize: '11px',
                                    color: validateLeaveStatusColor(
                                      leave.status
                                    )
                                  }}
                                  color="text.primary"
                                  gutterBottom
                                  noWrap
                                >
                                  {validateLeaveStatus(
                                    leave.status,
                                    leave.hrApproved,
                                    leave.typeName
                                  )}
                                </Typography>
                              </TableColumnCell>
                              <TableColumnCell>
                                {showActions ? (
                                  <div
                                    style={{
                                      background: 'transparent',
                                      marginLeft: 'auto'
                                    }}
                                  >
                                    <VisibilityOutlinedIcon
                                      onClick={() => {
                                        {
                                          query.get('name')
                                            ? navigate(
                                                `/leave-management/leave-view/${leave.id}?name=employeeLeaves?${id}`
                                              )
                                            : navigate(
                                                `/leave-management/leave-view/${leave.id}?name=history`
                                              );
                                        }
                                      }}
                                      style={{
                                        fontSize: '17px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                        marginLeft:
                                          id !== 'id' ? '13px' : '0px'
                                      }}
                                    />
                                    {id === 'id' && (
                                      <Tooltip
                                        title={getCancelTooltip(leave)}
                                        arrow
                                      >
                                        <span>
                                          <CancelPresentationOutlinedIcon
                                            onClick={() => {
                                              if (isCancellationInReview(leave)) {
                                                setSnackBarMessage(
                                                  CANCELLATION_IN_REVIEW_MESSAGE
                                                );
                                                setSnackbarSeverity('error');
                                                setSnackBarOpen(true);
                                                return;
                                              }
                                              if (isLeaveCancellable(leave)) {
                                                setLeaveData({
                                                  ...leave,
                                                  dayIndex: isChild
                                                    ? dayIndex
                                                    : undefined,
                                                  totalDays: isChild
                                                    ? totalDays
                                                    : undefined
                                                });
                                                setOpen(true);
                                              }
                                            }}
                                            style={{
                                              fontSize: '17px',
                                              opacity: isLeaveCancellable(leave)
                                                ? 1
                                                : 0.4,
                                              cursor: isLeaveCancellable(leave)
                                                ? 'pointer'
                                                : 'default',
                                              color: isLeaveCancellable(leave)
                                                ? '#FF1943'
                                                : '#9e9e9e'
                                            }}
                                          />
                                        </span>
                                      </Tooltip>
                                    )}
                                  </div>
                                ) : null}
                              </TableColumnCell>
                            </>
                          );
                        };

                        return (
                          <Fragment
                            key={
                              group.isGroup
                                ? `group-${group.groupId}`
                                : `leave-${parentLeave.id}`
                            }
                          >
                            <TableRow
                              className='leave-history-row'
                              hover
                              sx={
                                group.isGroup && isExpanded
                                  ? {
                                      backgroundColor: '#EAF6FF',
                                      '& .MuiTableCell-root': {
                                        backgroundColor: '#EAF6FF !important'
                                      },
                                      '& .MuiTableCell-root > div': {
                                        backgroundColor:
                                          'transparent !important'
                                      }
                                    }
                                  : undefined
                              }
                            >
                              {renderLeaveCells(parentLeave, {
                                showActions: !group.isGroup,
                                showExpand: group.isGroup,
                                isExpanded,
                                groupId: group.groupId
                              })}
                            </TableRow>
                            {group.isGroup &&
                              isExpanded &&
                              group.leaves.map((leave, dayIndex) => (
                                <TableRow
                                  hover
                                  key={`child-${leave.id}`}
                                  sx={{
                                    backgroundColor: '#FFFFFF',
                                    '& .MuiTableCell-root': {
                                      backgroundColor: '#FFFFFF !important',
                                      borderBottom:
                                        '1px solid #E8EAEE !important'
                                    },
                                    '& .MuiTableCell-root > div': {
                                      backgroundColor: 'transparent !important'
                                    }
                                  }}
                                >
                                  {renderLeaveCells(leave, {
                                    showActions: true,
                                    isChild: true,
                                    dayIndex,
                                    totalDays: group.leaves.length
                                  })}
                                </TableRow>
                              ))}
                          </Fragment>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              {paginatedLeaveList?.length === 0 && (
                <Typography
                  style={{
                    fontSize: '15px',
                    fontWeight: 'bold',
                    margin: '1rem',
                    textAlign: 'center'
                  }}
                  variant="body2"
                >
                  No Records Found
                </Typography>
              )}
              <Box p={2}>
                <TablePagination
                  sx={{
                    fontSize: '12px',
                    '.MuiTablePagination-displayedRows': {
                      fontSize: '12px'
                    },
                    '.MuiTablePagination-selectLabel': {
                      fontSize: '12px'
                    }
                  }}
                  component="div"
                  count={
                    groupedLeaveList?.length ? groupedLeaveList?.length : 0
                  }
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[10, 20, 30, 40, 50]}
                />
              </Box>
            </Card>
          </Grid>
          {query.get('name') && (
            <Grid xs={4} sx={{ marginLeft: '1rem' }}>
              <TotalLeaves employeeId={id} />
            </Grid>
          )}
        </Grid>
      </Grid>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <CancelLeaveModal
        open={open}
        toggle={toggle}
        data={leaveData}
        employeeId={employeeId}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
        getData={leavesHistory}
        onCancelSuccess={(leaveId) => {
          const snapshot = leaveList.map((item) => ({ ...item }));
          const cancelledLeave = snapshot.find(
            (item) => String(item.id) === String(leaveId)
          );
          const cancelledGroupId =
            cancelledLeave?.groupId || cancelledLeave?.group_id;
          const needsApproval = doesCancellationRequireApproval(cancelledLeave);
          const nextStatus = needsApproval
            ? 'CANCELLATION_REQUESTED'
            : 'CANCELLED';

          // Optimistic update for the selected day only
          setLeaveList((prev) =>
            prev.map((item) =>
              String(item.id) === String(leaveId)
                ? {
                    ...item,
                    status: nextStatus,
                    cancellationEligible: false,
                    cancellationIneligibleReason: needsApproval
                      ? CANCELLATION_IN_REVIEW_MESSAGE
                      : 'Leave already cancelled',
                    cancellationRequiresApproval: needsApproval
                  }
                : item
            )
          );

          dispatch(AppActions.showLoader());
          getLeaveHistory(employeeId)
            .then((res) => {
              const apiData = res?.data?.data || [];
              const merged = apiData.map((item) => {
                if (String(item.id) === String(leaveId)) {
                  return {
                    ...item,
                    status: item.status || nextStatus,
                    cancellationEligible: false,
                    cancellationIneligibleReason: needsApproval
                      ? CANCELLATION_IN_REVIEW_MESSAGE
                      : item.cancellationIneligibleReason ||
                        'Leave already cancelled'
                  };
                }

                const prev = snapshot.find(
                  (s) => String(s.id) === String(item.id)
                );
                const itemGroupId = item?.groupId || item?.group_id;

                // Keep other days in the same group unchanged if API
                // incorrectly marked them as Cancellation Requested too
                if (
                  cancelledGroupId &&
                  itemGroupId === cancelledGroupId &&
                  item.status === 'CANCELLATION_REQUESTED' &&
                  prev &&
                  prev.status !== 'CANCELLATION_REQUESTED' &&
                  prev.status !== 'CANCELLED'
                ) {
                  return {
                    ...item,
                    status: prev.status,
                    hrApproved: prev.hrApproved,
                    cancellationEligible: prev.cancellationEligible,
                    cancellationIneligibleReason:
                      prev.cancellationIneligibleReason,
                    cancellationRequiresApproval:
                      prev.cancellationRequiresApproval
                  };
                }

                return item;
              });

              setLeaveList(merged);
              getDropDownValues(merged);
              dispatch(AppActions.hideLoader());
            })
            .catch(() => {
              dispatch(AppActions.hideLoader());
            });
        }}
      />
    </>
  );
};

LeaveHistory.propTypes = {};

LeaveHistory.defaultProps = {};

export default LeaveHistory;
